export const TZ = 'Europe/Helsinki';

export const dtFmtDay = 'YYYY-MM-DD';
export const dtFmtSeconds = 'YYYY-MM-DDThh:mm:ss';
